import { dataType as types } from '@/constants/data-type';
import { getSafe } from '@/helpers/global';
import moment from 'moment';
import { utilsFunction } from './utilsFunction';
import { settingConfigs } from '@/configurations';
export const formatFunctions = {
  dataFormat
}

function dataFormat(value, type) {
  switch (type) {
    case types.TEXT:
      return value;
    case types.NUMBER:
      return getSafe(() => utilsFunction.formatNumber(
        value,
        settingConfigs.QUANTITY.decimal,
        settingConfigs.QUANTITY.decimalSeparator,
        settingConfigs.QUANTITY.thousandSeparator)
        , value);
    case types.CURRENCY:
      return getSafe(() => utilsFunction.formatNumber(
        value,
        settingConfigs.PRICE.decimal
      )
        , value);
    case types.AVG_PRICE:
      return getSafe(() => utilsFunction.formatNumber(
        value,
        settingConfigs.AVG_PRICE.decimal
      )
        , value);
    case types.SHORT_DATE:
      return value ? moment(value).format(settingConfigs.SHORT_DATE) : '-'
    case types.LONG_DATE:
      return value && value.trim() !=='' ? moment(value).format(settingConfigs.LONG_DATE) : '-'
    case types.PERCENT:
      return getSafe(() => utilsFunction.formatPercent(value), value);
    case types.CASH:
      return getSafe(() => utilsFunction.formatNumber(
        value,
        settingConfigs.CASH.decimal
      )
        , value);
    case types.Time_CHANGE:
      return getSafe(() => utilsFunction.dateStringFormat(Number(value)), value);  
    default:
      return value;
  }
}